<template>
  <div>
    <v-data-table
      :headers="headers.filter(a => a.show || a.active)"
      :items="items"
      multi-sort
      :footer-props="datatable_footer"
      :loading="loading"
      no-data-text="Нет данных для отображения"
    >
      <template v-slot:footer.page-text="{pageStart, pageStop, itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
      </template>
      <template v-slot:top>
        <v-card flat>
          <v-card-text>
            <v-row dense>
              <v-col
                cols="10"
                md="3"
              >
                <v-btn
                  color="primary"
                  outlined
                  @click="filter_dialog = true;"
                >
                  <v-icon class="ml-3">
                    mdi-filter-variant
                  </v-icon>
                  <span class="mx-3">ФИЛЬТРЫ</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
      <!-- <template v-slot:item.client="{ item }">
        <span v-if="item && item.client">
          {{ dict.client[item.client] }}
        </span>
      </template> -->
      <template v-slot:item.sum="{item}">
        {{ Number(item.sum).toFixed(2) }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-menu
          :close-on-content-click="false"
          :nudge-width="100"
          :nudge-bottom="12"
          offset-y
        >
          <template v-slot:activator="{ on, attrs, value }">
            <v-btn
              v-bind="attrs"
              color="primary"
              text
              v-on="on"
              @click="sheetitem = item"
            >
              <v-icon
                large
                class="beg_triangle"
              >
                mdi-menu-open
              </v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-list>
              <v-list-item
                v-if="!sheetitem.deleted"
                @click="onViewLink(sheetitem)"
              >
                <v-list-item-content>
                  Открыть
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="!sheetitem.deleted && ($store.state.access[15][3] || $store.state.access[15][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id)"
                @click="onChangeLink(sheetitem)"
              >
                <v-list-item-content>
                  Изменить
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </template>
    </v-data-table>
    <v-dialog
      v-model="filter_dialog"
      persistent
      max-width="900px"
    >
      <base-material-card
        color="primary"
        icon="mdi-filter-outline"
        inline
        class="filter_popup"
      >
        <v-card-title>
          <span class="text-h5">Фильтры</span>
        </v-card-title>
        <v-card-text>
          <v-tabs
            v-model="tab_index"
            vertical
          >
            <v-tab
              v-for="(tab, index) in filter_fields"
              :key="index"
            >
              <div class="filter_row">
                {{ tab.name }}
              </div>
            </v-tab>
            <v-tab-item
              v-for="(tab, index) in filter_fields"
              :key="index"
            >
              <v-card flat>
                <v-card-text>
                  <div
                    v-for="(field, index2) in tab.data"
                    :key="'i_'+index2"
                  >
                    <v-select
                      v-if="field.type=='select'"
                      v-model="field.value"
                      clearable
                      :label="field.name"
                      :items="field.select"
                      @change="filter.changed = true"
                    />
                    <div
                      v-else-if="field.type=='date'"
                      clearable
                      :label="field.name"
                      :items="field.select"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="field.date_select"
                            clearable
                            :label="field.name"
                            :items="[{value:'yesterday', text:'Вчера'},{value:'today', text:'Сегодня'},{value:'tomorrow', text:'Завтра'},{value:'date', text:'Конкретная дата'},{value:'period', text:'Период дат'}]"
                            @change="changeFilterDateType($event, index , field)"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="field.from"
                            :label="field.date_select == 'period' ? 'От' : 'Конкретная дата'"
                            :disabled="field.date_select !== 'period' && field.date_select !== 'date'"
                            type="date"
                            :max="max_date"
                            @input="filter.changed = true"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-if="field.date_select == 'period'"
                            v-model="field.to"
                            label="До"
                            type="date"
                            :max="max_date"
                            @input="filter.changed = true"
                          />
                        </v-col>
                      </v-row>
                    </div>
                    <div v-else-if="field.type=='number'">
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            :label="field.name"
                            readonly
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="field.min"
                            label="От"
                            type="number"
                            @input="filter.changed = true"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="field.max"
                            label="До"
                            type="number"
                            @input="filter.changed = true"
                          />
                        </v-col>
                      </v-row>
                    </div>
                    <v-text-field
                      v-else
                      v-model="field.value"
                      :label="field.name"
                      :type="field.type"
                      @input="filter.changed = true"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            width="80"
            color="primary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2 btn-hi-primary"
            @click="filter_dialog = false, set_filter()"
          >
            <span class="mx-10">Применить</span>
          </v-btn>
          <v-btn
            width="80"
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2 btn-hi-secondary"
            @click="filter_dialog = false"
          >
            <span class="mx-10">Закрыть</span>
          </v-btn>
        </v-card-actions>
      </base-material-card>
    </v-dialog>
  </div>
</template>
<script>
  import moment from 'moment'
  import { JustpayPointService } from "@/views/loyalty/shared/services/justpay-point-service"
export default {
  name: 'DashboardTableFavoritePoints',
  components: {},
  props: {
    period: {
      type: Number,
      default: 1,
    },
    dateFrom: { default: new Date() },
    dateTo: { default: new Date() }
  },
  data: () => ({
    total: 0,
    loading: false,
    loading_points: false,
    tab_index: 0,
    table_options: {
    },
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },

    items: [],
    headers: [
      {
        text: 'Действия',
        value: 'action',
        sortable: false,
        show: true
      },
      {
        text: 'Наименование',
        value: 'name',
        active: true,
        active_temp: false
      },
      {
        text: 'Сумма успешных платежей',
        value: 'sum',
        active: true,
        active_temp: false
      },
      {
        text: 'Количество',
        value: 'count',
        active: true,
        active_temp: false
      },
    ],
    filter_dialog: false,
    filter: {
      set: false
    },
    filter_fields: {
      common: {
        index: 0,
        name: "Основное",
        active: true,
        data: [
          {
            name: "Точка продаж",
            data: "point.name",
            type: "select",
            select: []
          },
          {
            name: "Выбор периода",
            data: "created",
            type: "date",
          },
        ]
      }
    },

    dialog: {
      headers: {
        show: false
      },
      points: {
        show: false
      },
    },

    /* search: "", */
    sheet: false,
    sheetmenu: true,
    sheetitem: {},
    form: {
    },

    points: []
  }),
  computed: {
    max_date: function () {
      return moment().format('YYYY-MM-DD')
    },
  },
  watch: {
    $props: {
      handler () {
        this.filter.changed = true
        let period_value = "today"
        let date = null
        switch (this.period) {
          case 0: // Вчера
            period_value = "yesterday"
            break
          case 1: // Сегодня
            period_value = "today"
            break
          case 2: // Неделя
            period_value = "period"
            date = {
              from: moment().add(-1, 'week').format('YYYY-MM-DD'),
              to: moment().format('YYYY-MM-DD')
            }
            break
          case 3: // Месяц
            period_value = "period"
            date = {
              from: moment().add(-1, 'month').format('YYYY-MM-DD'),
              to: moment().format('YYYY-MM-DD')
            }
            break
          case 4:
            period_value = "period"
            date = { from: this.dateFrom, to: this.dateTo }
            break
        }
        // this.filter_fields.common.data[0].date_select = period_value
        this.filter_fields.common.data = this.filter_fields.common.data.map(m => {
          if (m.data === 'created') {
            m.date_select = period_value
          }
          return m
        })
        this.changeFilterDateType(period_value, "common", this.filter_fields.common.data.find(f => f.data === 'created'))
        if (date) {
          // this.filter_fields.common.data[0].from = this.formatInputDate(date.from)
          // this.filter_fields.common.data[0].to = this.formatInputDate(date.to)
          this.filter_fields.common.data = this.filter_fields.common.data.map(m => {
            if (m.data === 'created') {
              m.from = this.formatInputDate(date.from)
              m.to = this.formatInputDate(date.to)
            }
            return m
          })
        }
        this.set_filter()
      },
      deep: true,
    }
  },
  async mounted () {
    /* await this.$nextTick() */
    const justpayPointService = new JustpayPointService()
    const points_for_filter = await justpayPointService.getPointsForPaymentFilter(this.$store.state.client.id)
    this.filter_fields.common.data.map(item => {
      if (item.data === 'point.name') {
        item.select = [...points_for_filter]
        return item
      }
    })
    this.filter.changed = true
    // this.filter_fields.common.data[0].date_select = "today"
    console.log('this.filter_fields.common.data', this.filter_fields.common.data)
    this.filter_fields.common.data = this.filter_fields.common.data.map(m => {
      if (m.data === 'created') {
        m.date_select = 'today'
      }
      return m
    })
    console.log('this.filter_fields.common.data 2', this.filter_fields.common.data)
    // this.changeFilterDateType("today", "common", this.filter_fields.common.data[0])
    this.changeFilterDateType("today", "common", this.filter_fields.common.data.find(f => f.data === 'created'))
    this.set_filter()
    /* this.load(); */
  },
  methods: {
    formatInputDate: function (_date) {
      const date = new Date(_date)
      let dd = date.getDate()
      if (dd < 10) dd = '0' + dd

      let mm = date.getMonth() + 1
      if (mm < 10) mm = '0' + mm

      let yyyy = date.getFullYear()
      if (yyyy < 10) yyyy = '0' + yyyy

      return yyyy + '-' + mm + '-' + dd
    },
    changeFilterDateType (value, tab, field) {
      this.filter.changed = true
      if (tab && field && value) {
        if (value !== 'period' && value !== 'date') {
          let date = 0
          if (value == 'today') {
            date = new Date()
          } else if (value == 'yesterday') {
            date = new Date().setDate(new Date().getDate() - 1)
          } else if (value == 'tomorrow') {
            date = new Date().setDate(new Date().getDate() + 1)
          }
          const formated_date = this.formatInputDate(date)
          field.from = formated_date
          field.to = formated_date
        }
        if (value == 'date') {
          field.to = ''
        }
      }
    },
    show_header_dialog: function () {
      for (const x in this.headers) {
        this.headers[x].active_temp = this.headers[x].active
      }
      this.dialog.headers.show = true
    },
    show_points_dialog: function () {
      // this.load_points()
      this.dialog.points.show = true
    },
    set_filter: function (flag) {
      if (this.filter.changed) this.filter.set = true
      this.filter.changed = false
      this.load()
      localStorage.setItem(this.entity, JSON.stringify(this.filter_fields))
    },
    load: function (clear) {
      this.loading = true
      const request = JSON.parse(JSON.stringify(this.form))
      if (this.filter.set) {
        request.data = JSON.parse(JSON.stringify(this.filter_fields))
        delete request.data.set
        delete request.data.changed
      }
      this.axios.post('/api/payment/stat/list', request)
        .then(result => {
          if (!result.data.error) {
            this.loading = false
            this.items = result.data.data
          }
        })
    },
    onChangeLink (item) {
      const routeData = this.$router.resolve({ path: '/client/point/change?', query: { id: item.id } })
      window.open(routeData.href, '_blank')
    },
    onViewLink (item) {
      const routeData = this.$router.resolve({ path: '/client/point/view?', query: { id: item.id } })
      window.open(routeData.href, '_blank')
    }
  },
}
</script>
<style lang="scss">

</style>
